import script from "./FastbookingTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./FastbookingTabs.vue?vue&type=script&setup=true&lang=js"

import "./FastbookingTabs.vue?vue&type=style&index=0&id=00a1f959&lang=scss"

const __exports__ = script;

export default __exports__